<h2 mat-dialog-title class="d-flex align-items-center">
  <mat-icon class="mr-2">event_available</mat-icon>
  Termin positioniert
</h2>

<mat-dialog-content class="termin-choice-content">
  <p class="mb-2">Der Termin wurde erfolgreich eingeplant.</p>
  <div class="termin-summary mb-3">
    <div><strong>Auftrag:</strong> {{ orderNumber }}</div>
    <div><strong>Datum:</strong> {{ dateLabel }}</div>
    <div><strong>Uhrzeit:</strong> {{ timeLabel }}</div>
    <div *ngIf="data.teamName"><strong>Team/Filiale:</strong> {{ data.teamName }}</div>
  </div>
  <p class="mb-0">Wie möchten Sie den Kunden informieren?</p>
</mat-dialog-content>

<mat-dialog-actions align="end" class="termin-choice-actions">
  <button mat-button type="button" (click)="cancel()">Schließen</button>
  <button mat-flat-button color="accent" type="button" (click)="chooseCall()">
    <mat-icon>phone</mat-icon>
    Anruf tätigen
  </button>
  <button mat-flat-button color="primary" type="button" (click)="chooseEmail()">
    <mat-icon>email</mat-icon>
    E-Mail schreiben
  </button>
</mat-dialog-actions>
